import { render, staticRenderFns } from "./getfree-cart-item.vue?vue&type=template&id=4624e182&scoped=true"
import script from "./getfree-cart-item.vue?vue&type=script&lang=js"
export * from "./getfree-cart-item.vue?vue&type=script&lang=js"
import style0 from "./getfree-cart-item.vue?vue&type=style&index=0&id=4624e182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624e182",
  null
  
)

export default component.exports